<app-content-header [contentHeader]="contentHeader"></app-content-header>

<div class="card">
    <div>
        <button type="button" class="btn btn-success" rippleEffect (click)="showReferenceDeviceDialog(null)">Kalibrasyon Hareketi Oluştur</button>

    </div>
    <ngx-datatable [rows]="rows" [rowHeight]="50" class="bootstrap core-bootstrap" style="cursor: pointer;" [messages]="{ 
        emptyMessage: 'Veri Yok',
        totalMessage: 'Toplam', 
        selectedMessage: 'Seçili'
      }" [limit]="selectedSize" [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50"
        [scrollbarH]="true">

        <ngx-datatable-column name="Serfika No" prop="certificateNo" [width]="100"></ngx-datatable-column>

        <ngx-datatable-column name="İzlenebilirlik" prop="traceability" [width]="100"></ngx-datatable-column>

        <ngx-datatable-column name="Kal. Tarihi" [width]="150">
            <ng-template let-row="row" ngx-datatable-cell-template>
                {{ row.calibrationDate | date:'dd.MM.yyyy' }}
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Gelecek Kal. Tarihi" [width]="150">
            <ng-template let-row="row" ngx-datatable-cell-template>
                {{ row.futureCalibrationDate | date:'dd.MM.yyyy' }}
            </ng-template>
        </ngx-datatable-column>


        <ngx-datatable-column name="Sertf. Belirsizliği" prop="calibrationCertificateUncertainty"
            [width]="100"></ngx-datatable-column>
        <ngx-datatable-column name="Kabul Kriteri" prop="acceptanceCriterion" [width]="100"></ngx-datatable-column>


        <ngx-datatable-column name="#" [width]="75" [sortable]="false">
            <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">
                    <!-- stopPropagation burada ekleniyor -->
                    <button class="btn btn-icon btn-flat-warning" (click)="showReferenceDeviceDialog(row.id)">
                        <span [data-feather]="'edit'"></span>
                    </button>
                </div>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-footer>
            <ng-template ngx-datatable-footer-template>
                <div class="datatable-footer-inner">
                    <div class="page-count">
                        Toplam Veri {{ totalCount }}
                    </div>
                    <ngb-pagination [collectionSize]="(totalCount / basicSelectedOption) * 10" [(page)]="pageBasic"
                        (pageChange)="onPageChange($event)" [maxSize]="5">
                        <ng-template ngbPaginationPrevious>
                            <span [data-feather]="'chevron-left'" [size]="18" [class]="'font-weight-bolder'"></span>
                        </ng-template>
                        <ng-template ngbPaginationNext>
                            <span [data-feather]="'chevron-right'" [size]="18" [class]="'font-weight-bolder'"></span>
                        </ng-template>
                    </ngb-pagination>
                </div>
            </ng-template>
        </ngx-datatable-footer>
    </ngx-datatable>
</div>